var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6214_12236)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 9.00029C1.33325 5.31814 4.31778 2.33362 7.99992 2.33362C11.6821 2.33362 14.6666 5.31814 14.6666 9.00029C14.6666 12.6824 11.6821 15.667 7.99992 15.667C4.31778 15.667 1.33325 12.6824 1.33325 9.00029ZM13.6666 9.00028C13.6666 5.87043 11.1298 3.33362 7.99992 3.33362C4.87006 3.33362 2.33325 5.87043 2.33325 9.00028C2.33325 12.1301 4.87006 14.667 7.99992 14.667C11.1298 14.667 13.6666 12.1301 13.6666 9.00028Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77417 5.7312C8.0273 5.7312 8.2365 5.9193 8.26961 6.16335L8.27417 6.2312L8.2739 9.17793L10.5437 10.5325C10.761 10.6622 10.8443 10.9309 10.7477 11.1574L10.7169 11.218C10.5872 11.4354 10.3185 11.5187 10.092 11.4221L10.0313 11.3913L7.51801 9.89193C7.38839 9.81461 7.30183 9.68373 7.27974 9.53703L7.27417 9.46253V6.2312C7.27417 5.95506 7.49803 5.7312 7.77417 5.7312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 4L4 1.5",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4L12 1.5",
    stroke: "black",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6214_12236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.12de83e5c6d61c7424b2e4973f93dd46.svg";
export { ForwardRef as ReactComponent };